import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';



import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'ngx-logout',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoutComponent implements OnInit {

  constructor(
    public authService: AuthService,
    public activatedRoute: ActivatedRoute,
              protected cd: ChangeDetectorRef,
              protected router: Router) {

  }

  ngOnInit() {
    this.authService.logout();
    this.router.navigateByUrl('login');
  }
}
